export default function getBase64(file, cb) {
  const reader = new FileReader();
  if (file !== undefined) {
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result);
    };
  }
}
